module.exports = __webpack_public_path__ + "img/water02.9a20e48e.png";